

import React from "react";
import { useTheme } from "./ThemeProvider";
import tinycolor from "tinycolor2";

const PrimaryButton = ({
    children,
    onClick,
    disabled,
    className = "",
    background,
    hover,
    active,
    style = {},
    ...props
}) => {
    const { currentTheme } = useTheme();
    const primaryColor = background || currentTheme?.color || '#14532d';
    const hoverColor = hover || tinycolor(primaryColor).lighten(8).toString();
    const activeColor = active || tinycolor(primaryColor).darken(8).toString();
    const [bg, setBg] = React.useState(primaryColor);

    // Update bg when theme/background changes
    React.useEffect(() => {
        setBg(primaryColor);
    }, [primaryColor]);

    return (
        <button
            onClick={onClick}
            disabled={disabled}
            className={`w-full max-w-xs md:w-auto px-3 py-2 md:px-6 md:py-2 text-white rounded-md font-medium shadow-md transition disabled:opacity-50 disabled:cursor-not-allowed focus:outline-none ${className}`}
            style={{
                background: bg,
                color: '#fff',
                border: 'none',
                ...style,
            }}
            onMouseOver={() => setBg(hoverColor)}
            onMouseOut={() => setBg(primaryColor)}
            onMouseDown={() => setBg(activeColor)}
            onMouseUp={() => setBg(hoverColor)}
            {...props}
        >
            {children}
        </button>
    );
};

export default PrimaryButton;
